export default class InventoryEmptyService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(inventoryEmpty, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryEmpty`, {
      body: JSON.stringify(inventoryEmpty),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryEmpty/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryEmpty/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryEmpty`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, inventoryEmpty, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryEmpty/${id}`, {
      body: JSON.stringify(inventoryEmpty),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }

  async sync(deleteMissing, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryEmpty/import/sync?deleteMissing=${deleteMissing}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return response.ok
  }
}